import React from 'react';
import styles from './Subtitle.module.scss';

export default function Subtitle({ children }) {
  return <h3 className={styles.subtitle}>{children}</h3>;
}
